<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'TercerosComponent',
  data: () => ({})
}
</script>